



















































































































































































































































/**
 * NOTE: When using the sync modifier, objects must always be passed with v-bind!
 *  ALl custom validations should evaluate to true to submit form. Invalid = false
 */
import { Component, Mixins, Watch } from "vue-property-decorator";
import Billing from "@/components/checkout/forms/Billing.vue";
import Contact from "@/components/checkout/forms/Contact.vue";
import Notes from "@/components/checkout/forms/Notes.vue";
import Payment from "@/components/checkout/forms/Payment.vue";
import Shipping from "@/components/checkout/forms/Shipping.vue";
import AccordionSectionCheckout from "@/components/elements/accordion/AccordionSectionCheckout.vue";
import { Address } from "@/models/address/address";
import {
  ChairOrderRecord,
  Order,
  OrderDetails,
  UmbrellaOrderRecord
} from "@/models/order/order";
import { NetSuiteCustomer, PaymentTerm } from "@/models/netsuite/netsuite";
import { EventBus } from "@/event-bus";
import { GenericError } from "@/services/error_service";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderActions, OrderGetters } from "@/store/modules/order/types";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import { PriceLevel } from "@/models/netsuite/netsuite";
import {
  CustomChairOrder,
  CustomUmbrellaOrder
} from "@/models/configurator/custom_umbrella";
import { ProductType } from "@/models/products/product";
import { Mobile } from "@/mixins/mobile";
import { OrderMixin } from "@/mixins/orders/mixin";

// Module-level cache: survives component destroy/recreate during navigation
let cachedFullCustomer: NetSuiteCustomer | null = null;
let cachedPaymentTerms: PaymentTerm[] = [];

@Component({
  components: {
    AccordionSectionCheckout,
    Billing,
    Contact,
    Notes,
    Payment,
    Shipping
  }
})
export default class CheckoutForm extends Mixins(Mobile, OrderMixin) {
  @(namespace(StoreModule.Order).Action(OrderActions.AddShipping))
  addShipping!: (value: OrderDetails["shipping_details"]) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AddBilling))
  addBilling!: (value: OrderDetails["billing_details"]) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AddPayment))
  addPayment!: (value: OrderDetails["payment_details"]) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AddContact))
  addContact!: (value: OrderDetails["contact_details"]) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AddNotes))
  addNotes!: (value: string) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AddOrderId))
  addOrderId!: (value: { id: string }) => Promise<void>;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetRole))
  userRole!: string;
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrder))
  storeOrder!: Order;
  @(namespace(StoreModule.Order).Action(OrderActions.AssignCustomer))
  assignCustomer!: (value: {
    customer_id: string;
    customer_name: string;
    customer_netsuite_id: number | undefined;
    customer_netsuite_contact_id: number | undefined;
    customer_netsuite_payment_terms_id: number | undefined;
    customer_netsuite_price_level_id: number | undefined;
    customer_netsuite_price_level_discount: number | undefined;
    order_id: string | null;
  }) => Promise<void>;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetPriceLevels))
  storePriceLevels!: PriceLevel[];
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: PriceLevel | null) => Promise<void>;

  protected loader: any = null;
  protected fullCustomer: NetSuiteCustomer | null = null;
  protected paymentTerms: PaymentTerm[] = [];
  protected error = {
    billing: false,
    shipping: false,
    payment: false,
    contact: false
  };
  protected order: OrderDetails = {
    contact_details: {
      quote_name: "",
      company_name: "",
      title: "",
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
      contact_id: null,
      send_email: false
    },
    shipping_details: {
      label: "",
      addressee: "",
      attention: "",
      address: {
        country: "US"
      } as Address,
      phone: "",
      email: "",
      freight_instructions: ""
    },
    billing_details: {
      addressee: "",
      attention: "",
      address: {
        country: "US"
      } as Address,
      phone: "",
      email: ""
    },
    payment_details: {
      method: undefined
    },
    notes: ""
  };
  async created(): Promise<void> {
    EventBus.$on("reviewQuote", this.goToReview);
    await this.initializeFromCustomer();
  }

  beforeDestroy(): void {
    EventBus.$off("reviewQuote", this.goToReview);
  }

  @Watch("storeOrder.customer_id")
  async onCustomerChanged(): Promise<void> {
    await this.initializeFromCustomer();
  }

  async initializeFromCustomer(): Promise<void> {
    // When returning from OrderReview, restore form data and cached API data
    // without making any API calls or showing a loader.
    if (cachedFullCustomer || cachedPaymentTerms.length > 0) {
      this.order = Object.assign({}, { ...this.storeOrder });
      this.fullCustomer = cachedFullCustomer;
      this.paymentTerms = cachedPaymentTerms;
      // Clear cache so subsequent customer changes go through normal flow
      cachedFullCustomer = null;
      cachedPaymentTerms = [];
      return;
    }

    if (this.storeOrder.customer_netsuite_id) {
      this.loader = this.$loading.show(
        { opacity: 1 },
        {
          before: this.$createElement("h1", "Obtaining Customer Details")
        }
      );
    }
    this.fullCustomer = null;
    this.order = Object.assign({}, { ...this.storeOrder });
    // Reset all form data so stale data from a previous customer doesn't carry over
    this.order.contact_details = {
      quote_name: "",
      company_name: "",
      title: "",
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
      contact_id: null,
      send_email: false
    };
    this.order.billing_details = {
      addressee: "",
      attention: "",
      address: { country: "US" } as Address,
      phone: "",
      email: ""
    };
    this.order.shipping_details = {
      label: "",
      addressee: "",
      attention: "",
      address: { country: "US" } as Address,
      phone: "",
      email: "",
      freight_instructions: ""
    };
    // Always reset payment method — will be auto-set for existing customers below,
    // or manually selected by the user for new/general customers
    if (this.order.payment_details) {
      this.order.payment_details.method = undefined;
    }
    if (this.storeOrder.customer_netsuite_id) {
      try {
        const [customer, terms] = await Promise.all([
          this.netSuiteService.getNetSuiteCustomerById(
            this.storeOrder.customer_netsuite_id.toString()
          ),
          this.paymentTerms.length
            ? Promise.resolve(this.paymentTerms)
            : this.netSuiteService.getPaymentTerms()
        ]);
        this.fullCustomer = customer;
        this.paymentTerms = terms;
        if (!this.order.contact_details.company_name) {
          this.order.contact_details.company_name = this.fullCustomer.company_name;
        }
        // Auto-select payment term for existing customer
        const paymentTermsId =
          this.storeOrder.customer_netsuite_payment_terms_id ??
          this.fullCustomer.payment_terms_id;
        if (paymentTermsId) {
          this.order.payment_details!.method = paymentTermsId;
        }
      } catch (err) {
        console.error(
          "Error pre-populating checkout from NetSuite customer:",
          err
        );
      }
    } else {
      if (!this.paymentTerms.length) {
        try {
          this.paymentTerms = await this.netSuiteService.getPaymentTerms();
        } catch (err) {
          console.error("Error fetching payment terms:", err);
        }
      }
    }
    if (this.loader) {
      setTimeout(() => this.loader.hide(), 300);
    }
  }

  get hasCustomer(): boolean {
    return !!this.storeOrder.customer_id;
  }

  get isNewCustomer(): boolean {
    return !this.storeOrder.customer_netsuite_id;
  }

  protected openCustomerModal(): void {
    EventBus.$emit("openCustomerModal");
  }

  protected async setNewCustomer(): Promise<void> {
    await this.assignCustomer({
      customer_id: "0",
      customer_name: "New Customer",
      customer_netsuite_id: undefined,
      customer_netsuite_contact_id: undefined,
      customer_netsuite_payment_terms_id: undefined,
      customer_netsuite_price_level_id: undefined,
      customer_netsuite_price_level_discount: undefined,
      order_id: null
    });
    const basePrice = this.storePriceLevels.find(l => l.name === "Base Price") ?? null;
    await this.addMultiplier(basePrice);
  }

  get availablePaymentTerms(): PaymentTerm[] {
    if (this.isNewCustomer) {
      return this.paymentTerms;
    }
    // Store value may be undefined for customers selected before this field was added (stale localStorage).
    // Fall back to the freshly-fetched fullCustomer data.
    const customerTermsId =
      this.storeOrder.customer_netsuite_payment_terms_id ??
      this.fullCustomer?.payment_terms_id;
    if (customerTermsId) {
      return this.paymentTerms.filter(t => t.id === customerTermsId);
    }
    return this.paymentTerms;
  }

  protected activePanel = 0;

  protected switchPanel(index: number): void {
    this.activePanel = index;
  }

  protected togglePanel(index: number, val: boolean): void {
    this.activePanel = val ? index : -1;
  }

  protected setBillingInfo(same: boolean): void {
    if (same) {
      const shipping = this.order.shipping_details;
      if (!shipping) return;
      this.order.billing_details = Object.assign(
        {},
        { ...this.order.billing_details },
        {
          addressee: shipping.addressee,
          attention: shipping.attention,
          address: Object.assign({}, shipping.address),
          phone: shipping.phone,
          email: shipping.email
        }
      );
    } else {
      this.order.billing_details = {
        addressee: "",
        attention: "",
        address: { country: "US" } as Address,
        phone: "",
        email: ""
      };
    }
  }

  protected async goToReview(): Promise<void> {
    EventBus.$emit("submitCheckoutForm");
    let invalid = false;
    for (const value of Object.values(this.error)) {
      if (value) {
        invalid = true;
      }
    }
    if (!invalid) {
      await this.saveDataToStore();
      // Cache API data so it can be restored without re-fetching when navigating back
      cachedFullCustomer = this.fullCustomer;
      cachedPaymentTerms = this.paymentTerms;
      this.$router.push({
        name: "OrderReview",
        params: {
          order: this.order as any,
          paymentTerms: this.paymentTerms as any
        }
      });
    }
  }

  protected async saveDataToStore(): Promise<void> {
    const shipping = this.order.shipping_details;
    if (shipping && !shipping.label) {
      shipping.label = shipping.address?.address_1 ?? "";
    }

    await this.addShipping(this.order.shipping_details);
    await this.addBilling(this.order.billing_details);
    await this.addPayment(this.order.payment_details);
    await this.addContact(this.order.contact_details);
    await this.addNotes(this.order.notes);
  }

  protected async prepQuoteData(): Promise<void> {
    try {
      await this.saveDataToStore();
      const order = await this.parseItems();
      if (this.storeOrder._id) {
        await this.updateQuote(order);
      } else {
        await this.createQuote(order);
      }
    } catch (err) {
      GenericError.popup("Something went wrong.");
    }
  }

  /**
   * The API expects only mfr_codes for fabric swatches. We save the entire fabric swatch object on the frontend because the fabric selector needs the extra data to do filtering
   */
  protected async parseItems(): Promise<Order> {
    const items = JSON.parse(JSON.stringify(this.storeOrder.items!));
    for (const item of items) {
      if (item.product_type === ProductType.Umbrella) {
        const parsedData = this.parseFabricFields(
          (item.item_details as CustomUmbrellaOrder)
            .canopy as CustomUmbrellaOrder["canopy"]
        );
        (item.item_details as CustomUmbrellaOrder).canopy = Object.assign(
          {},
          { ...(item.item_details as CustomUmbrellaOrder).canopy },
          { ...parsedData }
        );
      } else if (item.product_type === ProductType.Chair) {
        const parsedData = this.parseFabricFields(
          item.item_details as CustomChairOrder
        );
        (item.item_details as any) = Object.assign(
          {},
          { ...item.item_details },
          { ...parsedData } as ChairOrderRecord
        );
      }
    }
    const order = { ...this.storeOrder };
    order.items = [...items];
    return order;
  }

  /**
   * API is expecting strings for fabrics. parseFabricFields() convert swatch objects to strings if value is not already a string
   */
  protected parseFabricFields(
    fabric: CustomUmbrellaOrder["canopy"] | CustomChairOrder
  ): UmbrellaOrderRecord | ChairOrderRecord {
    const fabrics = [
      "mainFabric",
      "mainTrimFabric",
      "mainTrimFabricInner",
      "ventTopFabric",
      "ventMiddleFabric",
      "ventTrimFabric",
      "valanceFabric",
      "fringeFabric",
      "bindingFabric",
      "ribFabric",
      "undersideFabric"
    ];
    const parsed = {} as UmbrellaOrderRecord;
    for (const fabricKey of fabrics) {
      if (fabric[fabricKey] && fabric[fabricKey].mfr_code) {
        parsed[fabricKey] = fabric[fabricKey].mfr_code;
      } else if (
        fabric[fabricKey] &&
        Array.isArray(fabric[fabricKey]) &&
        fabric[fabricKey].length > 0
      ) {
        parsed[fabricKey] = fabric[fabricKey].map(swatch => {
          if (swatch.mfr_code) {
            return swatch.mfr_code;
          } else {
            return swatch;
          }
        });
      } else {
        parsed[fabricKey] = fabric[fabricKey];
      }
    }
    return parsed;
  }

  protected async createQuote(order: Order): Promise<void> {
    try {
      // ToDo: FNSI-101 - create NetSuite quote and then create unofficial quote.
      // commenting out the unofficial quote creation for now until we optimize the auth process and can associate quotes with users properly
      // DETERMINING IF WE CAN ELIMINATE THE "UNOFFICIAL" QUOTE CONCEPT ALTOGETHER AND JUST HAVE NETSUITE QUOTES
      const res = await this.createNetSuiteQuote(order);
      // const quote = await this.orderService.createQuote(order);
      // await this.addOrderId({ id: quote._id!, creator: quote.creator_id });
      const query: Record<string, string> = { type: "quote" };
      if (order.contact_details?.send_email) {
        query.emailSent = "1";
      }
      if (res?.estimate?.estimateId) {
        query.quoteId = String(res.estimate.estimateId);
      }
      if (res?.estimate?.tranId) {
        query.tranId = res.estimate.tranId;
      }
      await this.$router.push({ path: "/checkout/submitted", query });
    } catch (err) {
      GenericError.popup(err.message);
    }
  }

  protected async updateQuote(order: Order): Promise<void> {
    try {
      // ToDo: FNSI-101 - update NetSuite quote and then update unofficial quote
      // START FROM SCRATCH - NEED FULL ABILITY TO UPDATE AN EXISTING QUOTE (API ENDPOINT NEEDED FROM JOE)
      // DETERMINING IF WE CAN ELIMINATE THE "UNOFFICIAL" QUOTE CONCEPT ALTOGETHER AND JUST HAVE NETSUITE QUOTES
      await this.orderService.updateQuote(this.storeOrder._id!, order);
      this.$router.push("/checkout/submitted?type=quote");
    } catch (err) {
      GenericError.popup(err.message);
    }
  }

  protected async createOrder(order: Order): Promise<void> {
    try {
      // ToDo: FNSI-101 - create NetSuite quote, request for that quote to be submitted, and then create the unofficial order through the Node API
      // DETERMINING IF WE CAN ELIMINATE THE "UNOFFICIAL" ORDER CONCEPT ALTOGETHER AND JUST HAVE NETSUITE ORDERS
      const res = await this.orderService.createOrder(order);
      this.$router.push("/checkout/submitted?type=order");
    } catch (err) {
      GenericError.popup(err.message);
    }
  }

  protected async convertToOrder(order: Order): Promise<void> {
    try {
      const res = await this.orderService.convertOrderToQuote(
        order._id!,
        order
      );
      this.$router.push("/checkout/submitted?type=order");
    } catch (err) {
      GenericError.popup(err.message);
    }
  }

  protected receiveError(
    invalid: boolean,
    component: "billing" | "shipping" | "payment" | "contact"
  ) {
    if (
      this.isNewCustomer &&
      (component === "billing" || component === "payment")
    ) {
      this.error[component] = false;
      return;
    }
    this.error[component] = invalid;
  }
}
